import { render, staticRenderFns } from "./ReportsProjects.vue?vue&type=template&id=9192af96"
import script from "./ReportsProjects.vue?vue&type=script&lang=js"
export * from "./ReportsProjects.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports